<template>
  <div class="footer">
    <div class="content-box" style="display: flex;flex-direction: column;justify-content: center">
      <div class="box">
        <div class="li">
          <a href="http://www.med.tsinghua.edu.cn/" target="_blank">清华大学医学院</a>
          <a href="http://life.tsinghua.edu.cn/" target="_blank">清华大学生命科学学院</a>
          <a href="http://www.cls.edu.cn/" target="_blank">生命科学联合中心</a>
          <a href="http://www.icsb.tsinghua.edu.cn/" target="_blank">结构生物学高精尖创新中心</a>
          <a href="https://www.tsinghua.edu.cn/" target="_blank">清华大学</a>
          <!--        <a href="http://www.moebioinfo.tsinghua.edu.cn/" target="_blank">生物信息学教育部重点实验室</a>-->
        </div>
        <div>Copyright © 2020 沈晓骅实验室.
          <a style="margin-top: 5px" href="http://www.beian.miit.gov.cn/" target="_blank">京ICP备20025642号</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  width: 100%;
  min-width: 936px;
  height: 200px;
  background: rgba(216, 216, 216, 1) linear-gradient(162deg, rgba(77, 97, 161, 1) 0%, rgba(39, 55, 94, 1) 100%, rgba(48, 64, 91, 1) 100%);
  text-align: center;
  font-size: 12px;
  color: rgba(208, 229, 255, 1);
}

.box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.beian {
  text-align: center;
}

.footer a {
  margin-bottom: 5px;
  text-align: left;
  display: block;
  text-decoration: none;
  color: rgba(208, 229, 255, 1);
}

.footer a:hover {
  color: white;
}

.footer a:last-child {
  margin-bottom: 0;
}
</style>
